import AOS from 'aos';
import * as GLOBALS from '../globals';

export default class AOSClass {
    static init() {
        return new AOSClass();
    }

    constructor() {
        AOS.init({
            duration: 700
        });

        this.resetCardDelay();
        
        window.addEventListener("resize", this.resetCardDelay);

        Livewire.hook('morphed', ({el, component}) => {
            AOS.refresh();
        })
    }

    resetCardDelay() {
        const cardsWrapper = document.querySelectorAll('[class^=cards]');

        if (cardsWrapper == null) return;

        cardsWrapper.forEach((cardWrapper) => {
            const cards = cardWrapper.querySelectorAll('[class^=card]');
            
            cards.forEach((card) => {
                if (card.dataset.index == null) return;
                
                let modulus = 1;

                if (cardWrapper.dataset.columnSize == 'halfs') {
                    if (window.innerWidth > GLOBALS.BREAKPOINT_MD) modulus = 2;
                } else if (cardWrapper.dataset.columnSize == 'thirds') {
                    if (window.innerWidth > GLOBALS.BREAKPOINT_MD) modulus = 2;
                    if (window.innerWidth > GLOBALS.BREAKPOINT_LG) modulus = 3;
                } else if (cardWrapper.dataset.columnSize == 'quarters') {
                    if (window.innerWidth > GLOBALS.BREAKPOINT_SM) modulus = 2;
                    if (window.innerWidth > GLOBALS.BREAKPOINT_MD) modulus = 3;
                    if (window.innerWidth > GLOBALS.BREAKPOINT_LG) modulus = 4;
                }

                card.setAttribute('data-aos-delay', (card.dataset.index % modulus) * 100);
            });
        });
    }
}